import { BASE, CATEGORY, COLOR, COLUMN, FORMATTING, JARGON, LAYOUT, PATH } from "../../modules/constants"
import { addPaddingRightToLastCell, calcStats, getCell, getCellWithTooltip, headCell, setStats } from "../../modules/table.funcs"
import { initStats2 } from "../../components/layout/InitStats"
import { formatInteger, } from "../../modules/utilities"

const { border1, integer, left, string } = FORMATTING
const borderLeft = border1
const stats2 = {}

export const createAdvisersListHeadersData = props => {
    // console.log('createAdvisersListHeadersData props:', props)
    const { portrait, showLogos, the350club } = props

    const starHead = headCell({
        align: left,
        id: COLUMN.STAR,
        width: LAYOUT.STAR_WIDTH,
    })

    const adviser = headCell({ align: left, id: COLUMN.ADVISER, label: "Adviser", tooltipTitle: "" })
    const adviserP = headCell({ align: left, id: COLUMN.ADVISER, label: "Adviser", paddingRight: 2, tooltipTitle: "" })

    const asAuditor = headCell({ id: COLUMN.AS_AUDITOR })
    const asRecruitingAdviser = headCell({ id: COLUMN.AS_RECRUITING_ADVISER })
    const asRemunerationAdviser = headCell({ id: COLUMN.AS_REMUNERATION_ADVISER })
    const asExternalReviewer = headCell({ id: COLUMN.AS_EXTERNAL_REVIEWER })

    const asAuditorP = headCell({ id: COLUMN.AS_AUDITOR, label: "Auditor", paddingRight: 2 })
    const asRecruitingAdviserP = headCell({ id: COLUMN.AS_RECRUITING_ADVISER, label: "Recr. Adviser", paddingRight: 2 })
    const asRemunerationAdviserP = headCell({ id: COLUMN.AS_REMUNERATION_ADVISER, label: "Remun. Adviser", paddingRight: 2 })
    const asExternalReviewerP = headCell({ id: COLUMN.AS_EXTERNAL_REVIEWER, label: "Board Reviewer", paddingRight: 2 })

    const total = headCell({ borderLeft: borderLeft, id: COLUMN.TOTAL_CLIENTS })

    let headCells = portrait
        ? [starHead, adviserP, asAuditorP, asRecruitingAdviserP, asRemunerationAdviserP, asExternalReviewerP]
        : [starHead, adviser, asAuditor, asRecruitingAdviser, asRemunerationAdviser, asExternalReviewer, total]

    if (the350club)
        headCells.shift() // Remove starHead

    addPaddingRightToLastCell(headCells)
    // console.log('headCells:', headCells)
    return headCells
}

export const createAdvisersListFooterData = props => {
    // console.log('createAdvisersListFooterData props:', props)
    const { portrait, stats, the350club } = props

    let column = null
    const tooltip = ""
    const lseCompaniesNameFoot = headCell({ id: COLUMN.NAME, align: left, label: `${formatInteger(stats.numRows)} ${stats.numRows === 1 ? JARGON.COMPANY : JARGON.COMPANIES}` })

    for (const property in stats2)
        calcStats(stats2[property])

    //#region  column cells
    column = COLUMN.ADVISER
    const suffix = ` ${stats2[column].total === 1 ? JARGON.ADVISER : JARGON.ADVISERS}`
    const adviser = {
        total: getCell({ align: left, column, suffix, tooltip, type: integer, value: stats2[column].total }),
        mean: getCell({ column })
    }

    column = COLUMN.STAR
    const starFoot = {
        total: getCell({ column }),
        mean: getCell({ column })
    }

    column = COLUMN.AS_AUDITOR
    const asAuditor = {
        total: getCell({ column, tooltip, type: integer, value: stats.asAuditor.total }),
        mean: getCell({ column, tooltip, type: integer, value: stats.asAuditor.mean }),
    }

    column = COLUMN.AS_RECRUITING_ADVISER
    const asRecruitingAdviser = {
        total: getCell({ column, tooltip, type: integer, value: stats.asRecruitingAdviser.total }),
        mean: getCell({ column, tooltip, type: integer, value: stats.asRecruitingAdviser.mean }),
    }

    column = COLUMN.AS_REMUNERATION_ADVISER
    const asRemunerationAdviser = {
        total: getCell({ column, tooltip, type: integer, value: stats.asRemunerationAdviser.total }),
        mean: getCell({ column, tooltip, type: integer, value: stats.asRemunerationAdviser.mean }),
    }

    column = COLUMN.AS_EXTERNAL_REVIEWER
    const asExternalReviewer = {
        total: getCell({ column, tooltip, type: integer, value: stats.asExternalReviewer.total }),
        mean: getCell({ column, tooltip, type: integer, value: stats.asExternalReviewer.mean })
    }
    column = COLUMN.TOTAL_CLIENTS
    const totalClients = {
        total: getCell({ column, borderLeft: borderLeft, tooltip, type: integer, value: stats.totalClients.total }),
        mean: getCell({ column, borderLeft: borderLeft, tooltip, type: integer, value: stats.totalClients.mean })
    }
    //#endregion column cells

    const footCells = {
        totals: portrait
            ? [starFoot.total, adviser.total, asAuditor.total, asRecruitingAdviser.total, asRemunerationAdviser.total, asExternalReviewer.total]
            : [starFoot.total, adviser.total, asAuditor.total, asRecruitingAdviser.total, asRemunerationAdviser.total, asExternalReviewer.total, totalClients.total],
        // means: portrait
        //     ? [starFoot.mean, adviser.mean, asExternalReviewer.mean] // portrait
        //     : [starFoot.mean, adviser.mean, asAuditor.mean, asRecruitingAdviser.mean, asRemunerationAdviser.mean, asExternalReviewer.mean, totalClients.mean], // landscape
    }

    if (the350club) {
        footCells.totals.shift() // Remove starFoot
    }

    addPaddingRightToLastCell(footCells.totals)
    // addPaddingRightToLastCell(footCells.means)
    return footCells
}

//#region Rows
// Returns an array of objects representing the rows in the advisers list table, created from the given props
export const createAdvisersListRowData = props => {
    // console.log('createAdvisersListRowData props:', props)
    const { items, stats } = props
    let rows = []
    const tooltipTitle = "" // JARGON.MORE_INFO

    initStats2(stats2)

    items.forEach(item => {
        rows.push(createAdviserListRow({ ...props, item, tooltipTitle }))
        ++stats.numRows
    })
    // console.log('rows:', rows)
    return rows
}

const COMPANY_COLUMN_MAP = {
    [COLUMN.AS_AUDITOR]: 'auditors',
    [COLUMN.AS_RECRUITING_ADVISER]: 'recruitingAdvisers',
    [COLUMN.AS_REMUNERATION_ADVISER]: 'remunerationAdvisers',
    [COLUMN.AS_EXTERNAL_REVIEWER]: 'lastReviewFacilitators',
}

// Returns an object representing a row in the advisers list table for the given item
const createAdviserListRow = props => {
    const { item, portrait, stats } = props

    const companyCells = Object.entries(COMPANY_COLUMN_MAP)
        .reduce((acc, [column, field]) => {

            const total = item[field]?.length ?? 0
            const percent = item.companyStats?.[field]?.percent ?? 0

            acc[column] = {
                sortValue: total,
                value: `${total} (${percent}%)`,
            }

            return acc
        }, {})

    const cellSpec = {
        [COLUMN.ADVISER]: {
            value: 1,
        },

        [COLUMN.NAME]: {
            align: left,
            type: string,
            value: item.name,
        },

        ...companyCells,

        [COLUMN.TOTAL_CLIENTS]: {
            borderLeft,
            type: integer,
            value: item.totalClients ?? 0,
        },
    }

    // NB: 'setStats()' accepts both a number or bool for its 1st parameter
    // since the unary '+' operator converts boolean into a number
    // @ts-ignore
    setStats(cellSpec[COLUMN.ADVISER].value, stats2[COLUMN.ADVISER], true)
    const tooltip = item.companyNumber ? null : JARGON.AMBIGUOUS_COMPANY

    const pr = portrait ? { paddingRight: 2 } : {}
    const name = getCellWithTooltip({ ...cellSpec[COLUMN.NAME], ...pr, tooltip })
    const asAuditor = getCellWithTooltip({ ...cellSpec[COLUMN.AS_AUDITOR], ...pr })
    const asRecruitingAdviser = getCellWithTooltip({ ...cellSpec[COLUMN.AS_RECRUITING_ADVISER], ...pr })
    const asRemunerationAdviser = getCellWithTooltip({ ...cellSpec[COLUMN.AS_REMUNERATION_ADVISER], ...pr })
    const asExternalReviewer = getCellWithTooltip({ ...cellSpec[COLUMN.AS_EXTERNAL_REVIEWER], ...pr })
    const totalClients = getCellWithTooltip({ ...cellSpec[COLUMN.TOTAL_CLIENTS], ...pr })

    setStats(item.auditors.length, stats.asAuditor, true)
    setStats(item.recruitingAdvisers.length, stats.asRecruitingAdviser, true)
    setStats(item.remunerationAdvisers.length, stats.asRemunerationAdviser, true)
    setStats(item.lastReviewFacilitators.length, stats.asExternalReviewer, true)
    setStats(item.totalClients, stats.totalClients, true)

    const cellWithTooltips = portrait
        ? [name, asAuditor, asRecruitingAdviser, asRemunerationAdviser, asExternalReviewer]
        : [name, asAuditor, asRecruitingAdviser, asRemunerationAdviser, asExternalReviewer, totalClients]

    addPaddingRightToLastCell(cellWithTooltips)

    return {
        _id: item.id,
        category: CATEGORY.COMPANY,
        cellWithTooltips,
        iconColor: COLOR.GOOD,
        ids: [item.companyNumber, item.lei].filter(Boolean),
        index: item.index,
        isFavourite: item.isFavourite ?? false,
        link: item.companyNumber ? `/company/${item.companyNumber}` : `/${PATH[BASE.ADVISER]}/${item.id}`,
        title: item.name,
    }
}
//#endregion Rows

